export const registerFinalizeReducerKey = 'registerFinalizeReducerKey';
export const registerFinalizeSetIpAddressReducerType = 'registerFinalizeSetIpAddressReducerType';
export const registerFinalizeSetIsLoadingReducerType = 'registerFinalizeSetIsLoadingReducerType';
export const registerFinalizeSetFailReducerType = 'registerFinalizeSetFailReducerType';
export const registerFinalizeSetMarketingInfoReducerType = 'registerFinalizeSetMarketingInfoReducerType';
export const registerFinalizeSetDataReducerType = 'registerFinalizeSetDataReducerType';
